import { render, staticRenderFns } from "./HighlightedBox.vue?vue&type=template&id=58399024&scoped=true&"
import script from "./HighlightedBox.vue?vue&type=script&lang=js&"
export * from "./HighlightedBox.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedBox.vue?vue&type=style&index=0&id=58399024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58399024",
  null
  
)

export default component.exports